import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { lastBrandAccountIdAtom } from '~/atoms'
import {
  RedirectOrError,
  type RedirectOrErrorProps,
} from '~/components/features/RedirectOrError/'
import { useCommonQueryBrandAccounts } from '~/hooks/useCommonQuery'
import { applyIfExist, ensureExists, exists, findByPath } from '~/utils'

export const NinesegsAnalyzerTopPage = () => {
  const { t } = useTranslation()
  const brandAccounts = useCommonQueryBrandAccounts()
  const [lastBrandAccountId, setLastBrandAccountId] = useAtom(
    lastBrandAccountIdAtom,
  )
  const getRedirectPath = React.useCallback<
    RedirectOrErrorProps['getRedirectPath']
  >(() => {
    if (brandAccounts.length === 0) {
      return { success: false, error: t('brand_account_not_found') }
    }

    const lastBrandAccount = applyIfExist(
      lastBrandAccountId,
      (lastBrandAccountId) =>
        findByPath(brandAccounts, 'id', lastBrandAccountId),
    )
    if (exists(lastBrandAccount)) {
      return {
        success: true,
        path: compile('brandAccount', { brandAccountId: lastBrandAccount.id }),
      }
    } else {
      setLastBrandAccountId(undefined)
    }

    const earliestBrandAccount = R.pipe(brandAccounts, R.first(), ensureExists)

    return {
      success: true,
      path: compile('brandAccount', {
        brandAccountId: earliestBrandAccount.id,
      }),
    }
  }, [brandAccounts, lastBrandAccountId, setLastBrandAccountId, t])

  return <RedirectOrError getRedirectPath={getRedirectPath} />
}
